export default __webpack_public_path__ + "static/media/17.f931ec6c.jpg";